import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Wrench, ChevronRight } from 'lucide-react';
import { useAllPublisherConfigs } from '../../data/publisherConfigs';
import { isSelfServiceDevelopment } from '../../lib/env';

const DevMenu: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [publishersOpen, setPublishersOpen] = useState(false);
  const { configs } = useAllPublisherConfigs();
  if (!isSelfServiceDevelopment()) return null;

  const topLinks: { to: string; label: string }[] = [
    { to: '/', label: 'Browse channels' },
    { to: '/admin', label: 'Admin login' },
  ];

  return (
    <div className="fixed bottom-4 left-4 z-30">
      {open && (
        <div className="mb-2 rounded-lg bg-white shadow-lg border border-slate-200 overflow-hidden min-w-[240px] max-h-[70vh] overflow-y-auto">
          <div className="px-3 py-2 text-[10px] uppercase tracking-[0.14em] text-slate-400 border-b border-slate-100">
            Dev menu
          </div>
          {topLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
            >
              {l.label}
            </Link>
          ))}

          <button
            type="button"
            onClick={() => setPublishersOpen((v) => !v)}
            className="w-full flex items-center justify-between px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 border-t border-slate-100"
          >
            Publisher admin
            <ChevronRight className={`w-4 h-4 transition-transform ${publishersOpen ? 'rotate-90' : ''}`} />
          </button>

          {publishersOpen && (
            <div className="bg-slate-50 border-t border-slate-100">
              {configs.length === 0 && (
                <div className="px-3 py-2 text-xs text-slate-400">No publishers loaded</div>
              )}
              {configs.map((c) => (
                <div key={c.slug} className="px-3 py-2 border-b border-slate-200 last:border-b-0">
                  <div className="text-xs font-semibold text-slate-700 mb-1">{c.name}</div>
                  <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px]">
                    <Link onClick={() => setOpen(false)} to={`/admin/${c.slug}`} className="text-indigo-600 hover:underline">Dashboard</Link>
                    <Link onClick={() => setOpen(false)} to={`/admin/${c.slug}/submissions`} className="text-indigo-600 hover:underline">Submissions</Link>
                    <Link onClick={() => setOpen(false)} to={`/admin/${c.slug}/advertisers`} className="text-indigo-600 hover:underline">Advertisers</Link>
                    <Link onClick={() => setOpen(false)} to={`/admin/${c.slug}/payments`} className="text-indigo-600 hover:underline">Payments</Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Dev menu"
        className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-slate-900 text-white shadow-md hover:bg-slate-700 transition-colors"
      >
        <Wrench className="w-4 h-4" />
      </button>
    </div>
  );
};

export default DevMenu;
